import { render, staticRenderFns } from "./NewContact.vue?vue&type=template&id=7b7134da&"
import script from "./NewContact.vue?vue&type=script&lang=js&"
export * from "./NewContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports